import { merge } from '../../helper';

import alreadyTableBody from './utils/alreadyTableBody';
import alreadyTableEmpty from './utils/alreadyTableEmpty';

// ----------------------------------------------------------------------------

function clear(element: HTMLElement, config: Record<string, any> = {}): void {
    const defConfig: Record<string, any> = {
        empty: {
            enabled: true,
        },
    };

    merge(defConfig, config);

    const elTableBody = alreadyTableBody(element, defConfig.tbody);
    elTableBody.innerHTML = '';

    if (defConfig.empty?.enabled === true) {
        alreadyTableEmpty(element, defConfig.empty);
    }
}

// ----------------------------------------------------------------------------

export { clear };
